import { render } from "./ImageHeaderDisable.vue?vue&type=template&id=2308c63f&scoped=true"
import script from "./ImageHeaderDisable.vue?vue&type=script&lang=js"
export * from "./ImageHeaderDisable.vue?vue&type=script&lang=js"

import "./ImageHeaderDisable.vue?vue&type=style&index=0&id=2308c63f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2308c63f"]])

export default __exports__